import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <section className="not-found page-container">
      <p className="eyebrow">ERRO 404</p>
      <h1>Página não encontrada</h1>
      <p>Verifique o endereço ou retorne para o catálogo.</p>
      <Link className="primary-button" to="/">Ir para o início</Link>
    </section>
  );
}
